import { SkechersPoItemVariant } from "./skechers-po-item-variant";

export class SkechersPoItemDetails {

    poStyle: string;
    deliveryAddress:string;
    SkecherspoItemVariantDetails: SkechersPoItemVariant[]

}